module.exports = __webpack_public_path__ + "img/5-4.1fe13f71.png";